import { capitalize, toNumber, isNaN } from 'lodash'

export function capitalizeAllWords(fullString: string): string {
  return (
    fullString
      // need to replaceAll for nbsp;
      .replaceAll(/\s/g, ' ')
      .split(' ')
      .map(capitalize)
      .join(' ')
  )
}

export const parseToNumber = (str: string): number => {
  const num = toNumber(str)
  return isNaN(num) ? 0 : num
}

export function formatList(list: string[]): string {
  if (list.length === 0) {
    return ''
  }
  if (list.length === 1) {
    return list[0]
  }
  if (list.length === 2) {
    return list.join(' and ')
  }
  return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1]
}
